import React from 'react';
import { PromoterModel } from '@mm/state/model/PromoterModel';
import { ChatWidgetPreviewChannelOption } from '../ChatWidgetPreviewFrame/ChatWidgetPreviewFrame';
import { CustomerChatGreetingEditor } from '../CustomerChatGreetingEditor/CustomerChatGreetingEditor';
import { CustomerChatIconEditor } from '../CustomerChatIconEditor/CustomerChatIconEditor';

type Props = {
  promoter: PromoterModel;
  setPreviewChannel: (channel: ChatWidgetPreviewChannelOption) => void;
  usedInSlideout?: boolean;
  onAlertTextClick?: () => void;
};
export const CustomerChatAppearanceEditor = (props: Props) => {
  const { promoter, setPreviewChannel, usedInSlideout, onAlertTextClick } =
    props;

  return (
    <>
      <CustomerChatIconEditor
        promoter={promoter}
        setPreviewChannel={setPreviewChannel}
        usedInSlideout={usedInSlideout}
        onAlertTextClick={onAlertTextClick}
      />
      <CustomerChatGreetingEditor
        promoter={promoter}
        setPreviewChannel={setPreviewChannel}
        usedInSlideout={usedInSlideout}
        onAlertTextClick={onAlertTextClick}
      />
    </>
  );
};
